<template>
	<div class="am-map">
	</div>
</template>

<script>
import loadGoogleMapsApi from 'load-google-maps-api'

export default {
	props: {
		markers: {
			type: Array,
			default: () => ([])
		},
		center: {
			type: Object,
			default: () => ({ lat: -7.1137721, lng: -34.8332407 })
		},
		zoom: {
			type: Number,
			default: 14
		},
		icon: {
			type: String,
			default: '/images/pin.png'
		}
	},

	data: () => ({
		map: null
	}),

	mounted() {
		window.onload = () => {
			setTimeout(() => {
				if (window.google.maps === undefined)
					loadGoogleMapsApi({
						key: process.env.MAPS_KEY
					})
						.then(maps => this.init(maps))
				else
					this.init(window.google.maps)
			}, 5000)
		}
	},

	watch: {
		center(coords) {
			this.map.setCenter(coords)
		}
	},

	methods: {
		init(maps) {
			// Instantiate Google Map object
			this.map = new maps.Map(this.$el, {
				center: this.center,
				zoom: this.zoom,
				gestureHandling: 'cooperative',
				disableDefaultUI: true
			})

			// Add marker to center
			this.markers.forEach(marker => {
				new maps.Marker({
					position: marker,
					icon: {
						url: this.icon,
						size: new maps.Size(91, 111),
						origin: new maps.Point(0, 0),
						anchor: new maps.Point(45.5, 70)
					},
					map: this.map
				})
			})
		}
	}
}
</script>

<style lang="scss">
.am-map{
	min-height: 200px;
}
</style>
